<template>
  <pc v-if="isModel"></pc>
  <phone v-else></phone>
</template>

<script>
import Pc from './modules/pc.vue'
import Phone from './modules/phone.vue'
export default {
  name: 'Home',
  components: { Pc, Phone },
  data() {
    return {
      isModel: null
    }
  },
  created() {
    this.isModel = this.$isModel()
  }
}
</script>

<style lang="scss"></style>
